import React from "react";

import {
  EARLY_PAYOUT_FORM_LABELS,
  EARLY_PAYOUT_TEST_IDS,
} from "./earlyPayoutConstants";
import type { EarlyPayoutSoccerTotalCondition } from "./earlyPayoutTypes";
import { formatSoccerTotalLineLabel } from "./earlyPayoutUtils";
import styles from "./EarlyPayout.module.css";

type SoccerTotalConditionsViewProps = {
  conditions: EarlyPayoutSoccerTotalCondition[];
};

const SoccerTotalConditionsView: React.FC<SoccerTotalConditionsViewProps> = ({
  conditions,
}) => (
  <section
    className={styles["early-payout-conditions"]}
    data-testid={EARLY_PAYOUT_TEST_IDS.soccerTotalConditionsView}
  >
    <div className={styles["early-payout-conditions-heading"]}>
      {EARLY_PAYOUT_FORM_LABELS.conditions}
    </div>
    <div className={styles["early-payout-lines-card"]}>
      <div
        className={`${styles["early-payout-lines-grid"]} ${styles["early-payout-lines-grid-view"]}`}
      >
        <div className={styles["early-payout-lines-header"]}>
          {EARLY_PAYOUT_FORM_LABELS.lines}
          <span className={styles["early-payout-info-dot"]}>i</span>
        </div>
        <div className={styles["early-payout-lines-header"]}>
          {EARLY_PAYOUT_FORM_LABELS.timeStart}
          <span className={styles["early-payout-info-dot"]}>i</span>
        </div>
        <div className={styles["early-payout-lines-header"]}>
          {EARLY_PAYOUT_FORM_LABELS.timeEnd}
          <span className={styles["early-payout-info-dot"]}>i</span>
        </div>
        {conditions.map((condition) => (
          <React.Fragment key={String(condition.lineValue)}>
            <div className={styles["early-payout-line-label"]}>
              {formatSoccerTotalLineLabel(condition.lineValue)}
            </div>
            <div className={styles["early-payout-line-label"]}>
              {condition.timeStart}
            </div>
            <div className={styles["early-payout-line-label"]}>
              {condition.timeEnd}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  </section>
);

export default SoccerTotalConditionsView;
